/** @format */
import { TFunction } from 'next-i18next';

import { Market } from '@toucan/client/global/market';

export const getSavedProductsUrl = ({
    activeMarket,
    t,
}: {
    activeMarket: Market;
    t: TFunction;
}) => {
    const accountSlug = t('account', { ns: 'urls' });

    const savedProductsSlug = t('saved-products', {
        ns: 'urls',
    });

    return `/${activeMarket.slug}/${accountSlug}/${savedProductsSlug}`;
};

export const getButtonLabel = ({
    isSaved,
    t,
}: {
    isSaved: boolean;
    t: TFunction;
}) => {
    return isSaved
        ? t('Remove from saved products')
        : t('Add to saved products');
};
